module.exports = __webpack_public_path__ + "img/teaser_training11.5c2ffe9f.jpg";